import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import { controlCentreQueryKeys } from './controlCentreQueryKeys';

export function useGetControlCentreProperties() {
  return useQuery({
    queryKey: controlCentreQueryKeys.all,
    queryFn: ({ signal }) => PriceParrotService.getControlCentreProperties(signal),
  });
}
